import { DateTime } from "luxon";

export function getDateSequenceFormatting(
  items: string[]
): "WEEKDAYS" | "HOURS" | "DATES" {
  if (items.length === 0) {
    return "DATES";
  }
  if (
    // all the dates are one day appart
    items
      .slice()
      .reverse()
      .map((startAt, index) => {
        const skewDate = DateTime.fromISO(startAt).minus({
          days: index,
        });

        return skewDate.ordinal + ":" + skewDate.year;
      })
      .every((k, _i, arr) => k === arr[0])
  ) {
    return "WEEKDAYS";
  }

  const d = items.map((startAt) => {
    const skewDate = DateTime.fromISO(startAt);
    return skewDate.ordinal + ":" + skewDate.year;
  });
  if (
    // has dates that are on same day
    new Set(d).size !== d.length
  ) {
    return "HOURS";
  }
  return "DATES";
}
